"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _radioButton = _interopRequireDefault(require("../radioButton"));

var _constants = require("../../../assets/js/constants");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var RadioGroupContainer = _styledComponents["default"].div.withConfig({
  displayName: "radioGroup__RadioGroupContainer",
  componentId: "sc-1r1a7i5-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    flex-direction: ", ";\n    width: ", ";\n"])), function (props) {
  return props.direction ? props.direction : 'column';
}, function (props) {
  return props.bordered ? '100%' : 'auto';
});

var border = "1px solid ".concat(_constants.COLORS.lightGrey);

var RadioButtonContainer = _styledComponents["default"].div.withConfig({
  displayName: "radioGroup__RadioButtonContainer",
  componentId: "sc-1r1a7i5-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: 5px 0 8px;\n    border-top: ", ";\n    width: ", ";\n    &:last-of-type {\n        border-bottom: ", ";\n    }\n"])), function (props) {
  return props.bordered ? border : 'none';
}, function (props) {
  return props.itemWidth ? props.itemWidth : 'auto';
}, function (props) {
  return props.bordered ? border : 'none';
});

var RadioGroup = /*#__PURE__*/function (_Component) {
  _inherits(RadioGroup, _Component);

  var _super = _createSuper(RadioGroup);

  function RadioGroup() {
    _classCallCheck(this, RadioGroup);

    return _super.apply(this, arguments);
  }

  _createClass(RadioGroup, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          bordered = _this$props.bordered,
          direction = _this$props.direction,
          key = _this$props.key,
          options = _this$props.options,
          itemWidth = _this$props.itemWidth,
          name = _this$props.name,
          onChange = _this$props.onChange,
          selectedValue = _this$props.selectedValue;
      return /*#__PURE__*/_react["default"].createElement(RadioGroupContainer, {
        bordered: bordered,
        direction: direction,
        key: key
      }, options.map(function (option) {
        return /*#__PURE__*/_react["default"].createElement(RadioButtonContainer, {
          bordered: bordered,
          key: option.id,
          itemWidth: itemWidth
        }, /*#__PURE__*/_react["default"].createElement(_radioButton["default"], {
          name: name,
          id: option.id,
          value: option.value,
          label: option.label,
          onChange: onChange && onChange.bind(_this, option.value),
          checked: selectedValue == option.value,
          dataTest: option.dataTest
        }));
      }));
    }
  }]);

  return RadioGroup;
}(_react.Component);

var _default = RadioGroup;
exports["default"] = _default;